$(document).ready(function () {
    var owl = $('.mobiletxtcaro.owl-carousel');
    owl.owlCarousel({
        dots: true,
        margin: 15,
        navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
        autoplay: true,
        nav: false,
        dotsEach: false,
        loop: true,
        responsive: {
            0: {
                items: 1
            },
            500: {
                items: 1
            },
            576: {
                items: 1
            },
            768: {
                items: 1
            },
            1300: {
                items: 1
            },
            1400: {
                items: 1
            }
        }
    });
});